var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "journey-connection-property-base",
    { attrs: { label: _vm.label, forInput: "ConnectionDisabled" } },
    [
      _c("toggle", {
        attrs: {
          sync: true,
          labels: {
            checked: _vm.resource("Bool_Yes"),
            unchecked: _vm.resource("Bool_No")
          },
          width: 50
        },
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }